<template>
  <span class="cod_element">
    <span class="fam-code">{{ getCodeElement[0] }}</span> {{ getCodeElement[1] }} <span v-if="getCodeElement[2]">{{ getCodeElement[2]}}</span>
  </span>
</template>

<script>

export default{
  props: {
    elm: {type: Object, default: null}
  },

  data: function(){

    return {

    }

  },

  created: function() {

  },

  mounted: function() {

  },

  computed: {

    getCodeElement: function() {
      if (!this.elm) return;

      let str_name = '';

      // articolo singolo
      if (this.elm.cod_famiglia === '4TOOLS'){
        str_name = this.elm.cod_art.replace('  ', ' ').replace(',', '').replace('.', '');
      } else {
        if ('cod_art' in this.elm) {
          if (this.elm.cod_art.match(/^\d/)) {
            str_name = this.elm.cod_art.replace('  ', ' ').replace(',', '').replace('.', '');
          } else {
            str_name = this.elm.cod_art.replace(/[\d]/g, '').replace('  ', ' ').replace(',', '').replace('.', '');
          }
          /* 14/04/2022
          * MODIFICA per funzionamento con le card che hanno codice come identificativo invece di cod_art
          *
          * */
        } else if ('codice' in this.elm) {
          if (this.elm.codice.match(/^\d/)) {
            str_name = this.elm.codice.replace('  ', ' ').replace(',', '').replace('.', '');
          } else {
            str_name = this.elm.codice.replace(/[\d]/g, '').replace('  ', ' ').replace(',', '').replace('.', '');
          }
        }
        // gruppo famiglia
        else {
          if ('articles' in this.elm && this.elm.articles.length > 0) {
            str_name = this.elm.articles[0].cod_art.replace(/[\d]/g, '').replace('  ', ' ').replace(',', '').replace('.', '');
          } else {
            if ('family' in this.elm)
              str_name += ' ' + this.elm.family.codice;
            // if('category' in this.elm)
            //   str_name += ' ' + this.elm.category.codice;
            if ('color' in this.elm)
              str_name += ' ' + this.elm.color.codice;
          }

        }
      }
      return str_name.trim().split(' ');
    },
  },

  methods: {

  }

}
</script>

<style lang="scss" scoped>
.fam-code {
  font-weight: 900;
}

</style>
